import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export default (t: TFunction): any =>
  yup.object({
    description: yup.string().required(t('schema-MPConfig-form-description-required')),
    accessToken: yup.string().required(t('schema-MPPointConfig-form-accessToken-required')),
  });
